import React, { useState } from "react";
import { motion } from "framer-motion";
import JobCard from "../components/common/JobCard";
import jobsData from "../data/jobs.json";
import useLang from "../hooks/useLang";

const Careers = () => {
  const { t, dir } = useLang();
  const [deptFilter, setDeptFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  const departments = ["all", ...new Set(jobsData.map((j) => j.department))];
  const types = ["all", ...new Set(jobsData.map((j) => j.type))];

  const filtered = jobsData.filter((job) => {
    const deptMatch = deptFilter === "all" || job.department === deptFilter;
    const typeMatch = typeFilter === "all" || job.type === typeFilter;
    return deptMatch && typeMatch;
  });

  return (
    <div dir={dir} className="font-inter">
      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-b from-dark to-primary relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(225,29,72,0.1),transparent_60%)]" />
        <div className="container-site text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-block bg-accent/10 text-accent text-sm font-semibold px-4 py-1.5 rounded-full border border-accent/30 mb-5">
              {t("careers.badge")}
            </span>
            <h1 className="text-5xl font-bold text-white mb-5">{t("careers.title")}</h1>
            <p className="text-gray-300 text-xl max-w-2xl mx-auto">{t("careers.subtitle")}</p>
          </motion.div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 bg-white border-b border-gray-100">
        <div className="container-site">
          <div className="flex flex-wrap gap-4">
            <div>
              <label className="block text-xs text-gray-400 mb-1">{t("careers.filterDept")}</label>
              <select
                value={deptFilter}
                onChange={(e) => setDeptFilter(e.target.value)}
                className="border border-gray-200 rounded-xl px-4 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-accent/30 bg-white"
              >
                <option value="all">{t("careers.allDepts")}</option>
                {departments.slice(1).map((d) => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-400 mb-1">{t("careers.filterType")}</label>
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className="border border-gray-200 rounded-xl px-4 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-accent/30 bg-white"
              >
                <option value="all">{t("careers.allTypes")}</option>
                {types.slice(1).map((ty) => (
                  <option key={ty} value={ty}>{ty}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Jobs */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-8">
            {t("careers.openPositions")} ({filtered.length})
          </h2>
          {filtered.length > 0 ? (
            <div className="space-y-5">
              {filtered.map((job, i) => (
                <JobCard key={job.id} job={job} index={i} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20 text-gray-400">
              {t("careers.noJobs")}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Careers;
